<template>

    <MenuMain/>
<!--    <MenuBlank/>-->
    <HeadingSearch/>

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Search for a Client</h3>

                    <div class="field">
                        <label for="billingClient">Client Name</label>
                        <AutoComplete v-model="client" :dropdown="true"
                                      :multiple="false"
                                      :suggestions="filteredClients"
                                      @complete="searchClients($event)"
                                      field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <Button label="Search" class="mr-2 mb-2" @click="viewClient"></Button>


                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import HeadingSearch from "@/components/heading/common/HeadingSearch.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuMain from "@/components/menu/common/MenuMain.vue";
import ClientService from "@/service/ClientService";

export default {
    components: {
        HeadingSearch,
        MenuMain,
        IsoEvolveFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[PmConfiguration][mounted] System is active.");
                console.log("[PmConfiguration][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[PmConfiguration][mounted] System is NOT active.");
                console.log("[PmConfiguration][mounted] Error = ", e);

                this.userStore.clearUser;
                this.$router.push("login");
            });

        if (this.userStore.user === undefined) {
            console.log("[PmConfiguration][mounted] User is NOT defined.");

            this.userStore.clearUser;
            this.$router.push('login');
        } else {
            console.log("[PmConfiguration][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            UserService.getUser(this.userStore.user.id)
                .then(data => {
                    this.profile = data.data;
                    console.log("[PmConfiguration][mounted] Data = ", data);

                })
                .catch(e => {
                    console.log("[PmConfiguration][mounted] No user data found.");
                    console.log("[PmConfiguration][mounted] Error = ", e);

                    this.userStore.clearUser;
                    this.$router.push('login');
                });
        }
    },
    data() {

        return {
            profile: {},
            filteredClients: [],
            client: null
        }
    },
    methods: {
        async viewClient() {
            console.log("[" + name + "][viewClient] client = ", this.client);
            this.$router.push({ name: 'commonClients', query: { inputClientId: this.client.id } });
        },
        async searchClients(event) {
            console.log("[" + name + "][searchClients] event.query = ", event.query);

            try {
                const [clientData] = await Promise.all([
                    ClientService.searchCompanyClients(this.profile.companyId, event.query.toLowerCase())
                ]);

                this.filteredClients = clientData.data;
                console.log("[AppointmentsNew][mounted] clientData.data = ", clientData.data);

            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching additional data = ", e);
            }
        },
    }

};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
